import { apiAxios } from "../../apiConfig";

export const getStories = async () => {
  try {
    const response = await apiAxios.get("/stories");

    return response.data;
  } catch (error) {
    console.error("Error fetching stories:", error);
    throw error;
  }
};

export const deleteStory = async (storyId) => {
  try {
    const response = await apiAxios.delete(`/stories/${storyId}`);

    return response.data;
  } catch (error) {
    console.error("Error deleting story:", error);
    throw error;
  }
};
